














































import { Product, ApiResponsePlain } from '@/models'
import { Component, Prop, Vue } from 'vue-property-decorator'
import ApiClient from '@/services/api-client'
import { ActionTypes } from '@/store/action-types'

@Component
export default class ImportElementsProductModal extends Vue {
  @Prop({ required: true, type: Object }) product: Product

  public file: any = null

  hideModal() {
    this.resetForm()
    this.$bvModal.hide('importElementsProductModal')
  }

  private importFile() {
    ApiClient.importExcelTraductions(this.product.code, this.file)
      .then((response: ApiResponsePlain) => {
        if (response.success) {
          this.$store.dispatch(ActionTypes.SHOW_TOAST, {
            title: this.$t('import_product_modal_component.title'),
            variant: 'success',
            message: this.$t('import_product_modal_component.feedback_message_success')
          })
          this.$emit('elementUpdated', null)
          this.hideModal()
        } else {
          this.resetForm()
          this.$store.dispatch(ActionTypes.SHOW_TOAST, {
            title: this.$t('import_product_modal_component.title'),
            variant: 'danger',
            message: response.message
          })
        }
      })
      .catch(() => {
        this.resetForm()
        this.$store.dispatch(ActionTypes.SHOW_TOAST, {
          title: this.$t('import_product_modal_component.title'),
          variant: 'danger',
          message: this.$t('feedback.error_message_generic')
        })
      })
  }

  private resetForm() {
    this.file = null
  }
}
